import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

import { environment } from '../environments/environment';
import { Helpers } from 'src/helpers/helpers';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ICountService } from './icount.service';

@Injectable({
  providedIn: 'root'
})
export class PointService extends BaseService implements ICountService {
  
  constructor(private http: HttpClient,  helper: Helpers) {
    super(helper);
  }

  private pathAPI = environment.apiUrl;

  getCount(body: any) {
    return this.http.post<any>(this.pathAPI + 'PointTransaction/Count', body, super.header()).pipe(catchError(super.handleError));
  }
  getData(body: any) {
    return this.http.post<any>(this.pathAPI + 'PointTransaction', body, super.header()).pipe(catchError(super.handleError));
  }

  getPointsByUser(userId: any) {
    return this.http.get<any>(this.pathAPI + 'PointTransaction?UserId=' + userId, super.header()).pipe(catchError(super.handleError));
  }

  redeemPoints(data: any) {
    return this.http.post<any>(this.pathAPI + 'PointTransaction/Redeem', data, super.header()).pipe(catchError(super.handleError));
  }

}
